module.exports = __webpack_public_path__ + "img/c08_unitspearman_Normal_ua.08b6a7f9.webp";